<template>
  <div ref="searchWidget" class="search-widget">
    <!-- <input ref="keyword" :type="isSearchWithNumber ? 'number' : 'text'" :placeholder="$t(`SearchWidget.placeholderSearchWith${isSearchWithNumber ? 'Number' : 'Text'}`)" v-model="keyword" name="keyword" autocomplete="off" @focus="focus" @blur="blur"  @keydown="autoSwapMode" @keyup.down="down" @keyup.up="up" @keyup.enter="enter" @input="input" @click="input"> -->
    <input ref="keyword" type="text" :placeholder="$t(`SearchWidget.placeholderSearch`)" v-model="keyword" name="keyword" autocomplete="off" @focus="focus" @blur="blur" @keyup.down="down" @keyup.up="up" @keyup.enter="enter" @input="input" @click="input">
    <button @mousedown="mousedown" class="clear-button" @click="clickClearButton" v-show="(keyword !== '') || (keyword !== '' && showSuggestList)">
      <img @mousedown="mousedown" :src="util.getImagePath('x_blue@2x.png')" :srcset="util.getImageSet('x_blue')">
    </button>
    <!-- <button class="search-with-number-button" @click="clickSearchWithNumberButton" v-show="(!isSearchWithNumber) || (!isSearchWithNumber)">
      <img :src="util.getImagePath('keypad_blue@2x.png')" :srcset="util.getImageSet('keypad_blue')">
    </button>
    <button class="search-with-text-button" @click="clickSearchWithTextButton" v-show="(isSearchWithNumber) || (isSearchWithNumber)">
      <img :src="util.getImagePath('keyboard_blue@2x.png')" :srcset="util.getImageSet('keyboard_blue')">
    </button>
    <transition name="tooltip">
    <div class="tooltip" v-show="(isShowTooltip) || (isShowTooltip)">
      <label>{{ isSearchWithNumber ? $t('SearchWidget.tooltipSearchWithText') : $t('SearchWidget.tooltipSearchWithNumber') }}</label>
      <div class="arrow"></div>
    </div>
    </transition> -->
    <div ref="suggestList" class="suggest-list" v-show="showSuggestList">
      <div class="suggest" :class="{highlight: highlightSuggestIndex === index}" v-for="(suggest, index) in suggestList" :key="suggest.word" v-html="suggest.display_word" @click="clickSuggest(suggest.word)"></div>
    </div>
  </div>
</template>

<script>
import { setTimeout, clearTimeout } from 'timers'

export default {
  name: 'SearchWidget',
  props: {
    keyword: {
      type: String,
      default: ''
    },
    location: {
      type: Object,
      default: () => {
        return {
          lat: 13.764955,
          lon: 100.538317
        }
      }
    },
    zoom: {
      type: Number,
      default: 12
    }
  },
  data () {
    return {
      highlightSuggestIndex: -1,
      showSuggestList: false,
      suggestList: [],
      delayTimer: undefined,
      lastestTimeInput: `${new Date().getTime()}`,
      // isSearchWithNumber: /^[0-9]{8}$/.test(this.keyword) || this.keyword === '',
      // isShowTooltip: false,
      tooltipTimeout: undefined,
      oldPressKey: undefined,
      mousedownHappened: false
    }
  },
  mounted () {
    var self = this
    // document.querySelector('.search-with-number-button').onclick = function () {
    //   document.querySelector('.search-with-number-button').focus()
    // }
    // document.querySelector('.search-with-text-button').onclick = function () {
    //   document.querySelector('.search-with-text-button').focus()
    // }
    // self.$root.$on('clickOnWindow', self.clickOnWindow)
    // self.tooltipTimeout = setTimeout(() => {
    //   self.isShowTooltip = true
    //   self.tooltipTimeout = setTimeout(() => {
    //     self.isShowTooltip = false
    //   }, 5 * 1000)
    // }, 3 * 1000)
    window.onhashchange = () => {
      if (location.hash === '#search') {
        self.$root.$emit('focusSearchWidget')
        self.$root.$emit('hideTopNavbar')
        self.showSuggestList = true
        self.$refs['keyword'].focus()
      } else {
        setTimeout(() => {
          self.$root.$emit('blurSearchWidget')
          self.$root.$emit('showTopNavbar')
          self.showSuggestList = false
          self.$refs['keyword'].blur()
        }, document.documentElement.clientWidth > 768 ? 1000 : 0)
      }
    }
  },
  methods: {
    // autoSwapMode (e) {
    //   var self = this
    //   if (self.isSearchWithNumber && (/^[ก-๙a-zA-Z]$/.test(e.key)) && self.oldPressKey !== 'Control') {
    //     self.clickSearchWithTextButton()
    //     if (!self.isSearchWithNumber) {
    //       self.keyword += e.key
    //       self.$emit('update:keyword', self.keyword)
    //     }
    //   }
    //   self.oldPressKey = e.key
    // },
    // clickOnWindow (e) {
    //   var self = this
    //   self.showSuggestList = self.$refs['searchWidget'] === e.target || self.$refs['searchWidget'].contains(e.target)
    // },
    focus (e) {
      var self = this
      self.$refs['keyword'].select()
      if (document.documentElement.clientWidth > 768) {
        return
      }
      self.$router.push(`${self.$route.path}#search`)
      self.$root.$emit('focusSearchWidget')
      self.$root.$emit('hideTopNavbar', true)
      setTimeout(() => {
        self.showSuggestList = true
      }, 300)
    },
    blur (e) {
      var self = this
      var relatedTarget = e.relatedTarget
      if (self.mousedownHappened) {
        self.mousedownHappened = false
        return
      }
      if (relatedTarget !== null) {
        if (relatedTarget.className === 'search-with-number-button') {
          return
        }
        if (relatedTarget.className === 'search-with-text-button') {
          return
        }
        if (relatedTarget.className === 'clear-button') {
          return
        }
      }

      setTimeout(() => {
        if (location.hash === '#search') {
          self.$router.back()
        }
        self.$root.$emit('blurSearchWidget')
        self.$root.$emit('showTopNavbar', false)
        self.showSuggestList = false
      }, 300)
    },
    mousedown () {
      var self = this
      self.mousedownHappened = true
      setTimeout(() => {
        self.mousedownHappened = false
      }, 300)
    },
    down () {
      var self = this
      self.highlightSuggestIndex++
      if (self.highlightSuggestIndex >= self.suggestList.length) {
        self.highlightSuggestIndex = self.suggestList.length - 1
      }
      self.keyword = self.suggestList[self.highlightSuggestIndex].word
      self.$emit('update:keyword', self.keyword)
      self.updateScrollTop()
    },
    up () {
      var self = this
      self.highlightSuggestIndex--
      if (self.highlightSuggestIndex < 0) {
        self.highlightSuggestIndex = 0
      }
      self.keyword = self.suggestList[self.highlightSuggestIndex].word
      self.$emit('update:keyword', self.keyword)
      self.updateScrollTop()
    },
    updateScrollTop () {
      var self = this
      var suggest = self.$refs['suggestList']
      suggest.scrollTop = self.highlightSuggestIndex * 45
    },
    enter () {
      var self = this
      self.mousedownHappened = false
      if (self.keyword.length > 1) {
        self.showSuggestList = false
        if (/^\d\d\d\d \d\d\d\d$/.test(self.keyword)) {
          self.keyword = self.keyword.replace(' ', '')
        }
        // var path = ((self.isSearchWithNumber || /^[0-9]{8,9}$/.test(self.keyword)) && self.keyword.length >= 8 && self.keyword.length <= 9) ? `/${self.keyword.length === 8 ? 'p' : 't'}/${self.keyword}` : `/map/search/${encodeURIComponent(self.keyword)}/@${self.location.lat},${self.location.lon},${self.zoom},1,0`
        var path = ((/^[0-9]{8,9}$/.test(self.keyword)) && self.keyword.length >= 8 && self.keyword.length <= 9) ? `/${self.keyword.length === 8 ? 'p' : 't'}/${self.keyword}` : `/map/search/${encodeURIComponent(self.keyword)}/@${self.location.lat},${self.location.lon},${self.zoom},1,0`
        self.$router.push({
          path: path
        })
        self.$refs['keyword'].blur()
      }
    },
    input () {
      var self = this
      self.lastestTimeInput = `${new Date().getTime()}`
      clearTimeout(self.delayTimer)
      self.delayTimer = setTimeout(function () {
        self.highlightSuggestIndex = -1
        // if (self.keyword.length > 1 && !self.isSearchWithNumber) {
        if (self.keyword.length > 1) {
          self.suggest()
        } else if (self.keyword.length < 1) {
          self.history()
        } else {
          self.showSuggestList = false
        }
      }, 100)
    },
    clickClearButton () {
      var self = this
      self.$root.$emit('clearSearchWidget')
      self.keyword = ''
      self.$emit('update:keyword', self.keyword)
      setTimeout(() => {
        self.$refs['keyword'].focus()
        self.input()
      }, 30)
    },
    // clickSearchWithNumberButton () {
    //   var self = this
    //   clearTimeout(self.tooltipTimeout)
    //   self.isSearchWithNumber = true
    //   self.keyword = ''
    //   self.$emit('update:keyword', self.keyword)
    //   self.$refs['keyword'].setAttribute('type', self.util.isiOS() ? 'number' : 'number')
    //   self.$refs['keyword'].focus()
    //   self.isShowTooltip = false
    //   self.tooltipTimeout = setTimeout(() => {
    //     self.isShowTooltip = true
    //     self.tooltipTimeout = setTimeout(() => {
    //       self.isShowTooltip = false
    //     }, 5 * 1000)
    //   }, 500)
    //   self.input()
    // },
    // clickSearchWithTextButton () {
    //   var self = this
    //   clearTimeout(self.tooltipTimeout)
    //   self.isSearchWithNumber = false
    //   // self.keyword = ''
    //   // self.$emit('update:keyword', self.keyword)
    //   self.$refs['keyword'].setAttribute('type', 'text')
    //   self.$refs['keyword'].focus()
    //   self.isShowTooltip = false
    //   self.tooltipTimeout = setTimeout(() => {
    //     self.isShowTooltip = true
    //     self.tooltipTimeout = setTimeout(() => {
    //       self.isShowTooltip = false
    //     }, 5 * 1000)
    //   }, 500)
    //   self.input()
    // },
    history () {
      var self = this
      var userProfile = {}
      var uuid = JSON.parse(self.getPromptPaiCookies('Uuid'))
      var isAuthenticated = JSON.parse(self.getPromptPaiCookies('isAuthenticated'))
      if (isAuthenticated) {
        userProfile = JSON.parse(self.getPromptPaiCookies('UserProfile'))
        uuid = undefined
      }
      self.pp.getSearchHistory(
        'name' in userProfile ? userProfile.name : undefined,
        'longdousertoken' in userProfile ? userProfile.longdousertoken : undefined,
        uuid,
        self.lastestTimeInput,
        (result) => {
          if (result.status.code === 200 && result.response === self.lastestTimeInput) {
            self.suggestList = []
            for (var i = 0; i < result.data.length; i++) {
              var html = `<div style="font-family: Prompt; line-height: 1.25; font-weight: bold; ${document.documentElement.clientWidth <= 768 ? 'color: rgb(255, 255, 255);' : ''}">${result.data[i][`promptpai_name_${self.$i18n.locale}`]}</div>`
              let codeStyle = 'font-size: 14px; margin: 3px 12px 0px 0px; width: calc(50% - 18px - 12px);'
              const iconStyle = `width: 18px; height: 18px; filter: grayscale(1) invert(1) brightness(${document.documentElement.clientWidth <= 768 ? 1.5 : 0.5}); margin-right: 4px;`
              if (document.documentElement.clientWidth <= 768) {
                codeStyle += 'color: rgba(255, 255, 255, 0.9);'
              }
              html += `
              <div style="width: 100%; display: flex; flex-direction: row; justify-content: flex-start; align-items: center;">
                <img style="${iconStyle}" src="${self.util.getImagePath('pp_dark_blue@2x.png')}" srcset="${self.util.getImageSet('pp_dark_blue')}">
                <div style="${codeStyle}">${result.data[i].promptpai_id.substring(0, 4)} ${result.data[i].promptpai_id.substring(4, 8)}</div>`
              if (result.data[i].promptpai_telephone !== '') {
                html += `
                <img style="${iconStyle}" src="${self.util.getImagePath('tel_dark_blue@2x.png')}" srcset="${self.util.getImageSet('tel_dark_blue')}">
                <div style="${codeStyle}">${result.data[i].promptpai_telephone}</div>`
              }
              html += `</div>`

              self.suggestList.push({
                word: result.data[i].promptpai_id,
                display_word: html
              })
            }
            self.showSuggestList = true
          } else if (result.status.code === 401) {
            self.loginAgain()
          } else if (result.status.code === 403) {
          } else {
          }
        }
      )
    },
    suggest () {
      var self = this
      self.pp.suggestPlaces(
        self.keyword,
        self.lastestTimeInput,
        (result) => {
          if (result.status.code === 200 && result.response === self.lastestTimeInput) {
            result.data.forEach(e => {
              e.display_word = e.display_word.replace(/<FONT color=blue>/gi, `<span style="font-size: 16px; ${document.documentElement.clientWidth > 768 ? 'color: rgb(41, 148, 253);' : 'color: rgb(255, 255, 255); text-decoration: underline;'}">`).replace(/<\/FONT>/gi, `</span>`)
            })
            self.suggestList = result.data
            self.showSuggestList = true
          } else if (result.status.code === 401) {
            self.loginAgain()
          } else if (result.status.code === 403) {
          } else {
          }
        }
      )
    },
    clickSuggest (suggest) {
      var self = this
      window.gtag('event', 'click_suggest', {'event_category': 'engagement', 'event_label': `click_suggest_${suggest}`})
      self.suggestList = []
      self.keyword = suggest
      self.$emit('update:keyword', self.keyword)
      self.enter()
      setTimeout(() => {
        self.$root.$emit('blurSearchWidget')
        self.$root.$emit('showTopNavbar')
        self.showSuggestList = false
        self.$refs['keyword'].blur()
      }, document.documentElement.clientWidth > 768 ? 1000 : 0)
    }
  },
  watch: {
    keyword (newKeyword, oldKeyword) {
      var self = this
      self.$emit('update:keyword', self.keyword)
    }
  }
}
</script>

<style scoped>
  .search-widget {
    position: relative;
    display: flex;
    flex-direction: row;
    width: 100%;
  }

  input {
    width: 100%;
    height: 50px;
    border-radius: 25px;
    border: none;
    padding: 0px 50px 0px 25px;
    margin: 0px;
    text-indent: 2px;
    box-shadow: 0px 0px 4px 0 rgba(0, 0, 0, 0.4);
    -webkit-appearance: none;
    font-size: 18px;
    box-sizing: border-box;
  }

  ::-webkit-input-placeholder {
    font-size: 18px;
    color: rgb(120, 120, 120);
    font-family: Prompt;
  }

  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"],
  input[type="number"] {
    -moz-appearance: textfield;
  }

  button.clear-button {
    height: 32px;
    width: 32px;
    cursor: pointer;
    position: absolute;
    top: 9px;
    /* right: calc(32px + 9px); */
    right: 9px;
    padding: 0px;
    background-color: transparent;
    border: none;
    overflow: hidden;
  }

  button.clear-button > img {
    height: 32px;
    width: 32px;
  }

  button.search-with-number-button,
  button.search-with-text-button {
    height: 32px;
    width: 32px;
    cursor: pointer;
    position: absolute;
    top: 9px;
    right: 9px;
    padding: 0px;
    background-color: transparent;
    border: none;
    overflow: hidden;
  }

  button.search-with-number-button > img,
  button.search-with-text-button > img {
    height: 32px;
    width: 32px;
  }

  .loading-animation {
    transform: scale(calc(32/80));
    position: absolute;
    top: -15px;
    right: -18px;
  }

  .suggest-list {
    position: absolute;
    top: 60px;
    width: 100%;
    max-height: calc(100vh - 367px);
    border: none;
    background-color: rgba(255, 255, 255, 1);
    overflow: hidden;
    overflow-y: auto;
    box-shadow: 0px 0px 4px 0 rgba(0, 0, 0, 0.4);
    -webkit-appearance: none;
    border-radius: 12.5px;
    cursor: pointer;
  }

  .suggest-list::-webkit-scrollbar-button {
    height: 12.5px;
  }
  .suggest-list::-webkit-scrollbar-thumb {
    border: 2px solid rgb(255, 255, 255);
  }

  .suggest-list > .suggest {
    padding: 12.5px 25px;
  }

  .suggest-list > .suggest:hover,
  .suggest-list > .suggest.highlight {
    background-color: rgb(227, 227, 227);
  }

  .tooltip {
    position: absolute;
    top: -20px;
    right: calc(9px - ((80px - 32px) / 2));
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 80px;
  }

  .tooltip > label {
    background-color: rgb(41, 148, 253);
    color: rgb(255, 255, 255);
    border-radius: 13px;
    font-size: 16px;
    padding: 2px 11px;
    box-shadow: 0px 0px 4px 0 rgba(0, 0, 0, 0.4);
    -webkit-appearance: none;
    width: 100%;
    box-sizing: border-box;
    text-align: center;
  }

  .tooltip > .arrow {
    width: 0; 
    height: 0; 
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid rgb(41, 148, 253);
  }

  .tooltip-enter-active,
  .tooltip-leave-active {
    transition: all 0.5s;
  }
  .tooltip-enter {
    opacity: 0;
    transform: scale(0);
  }
  .tooltip-leave-to {
    opacity: 0;
    transform: scale(0);
  }

  @media only screen and (max-width: 768px) {
    /* input {
      height: 40px;
      border-radius: 20px;
      padding: 2px 40px 0px 20px;
      font-size: 22px;
    }

    button.clear-button {
      height: 24px;
      width: 24px;
      top: 8px;
      right: calc(24px + 8px);
    }

    button.clear-button > img {
      height: 24px;
      width: 24px;
    }

    button.search-with-number-button,
    button.search-with-text-button {
      height: 24px;
      width: 24px;
      top: 8px;
      right: 8px;
    }

    button.search-with-number-button > img,
    button.search-with-text-button > img {
      height: 24px;
      width: 24px;
    } */

    ::-webkit-input-placeholder {
      font-size: 18px;
    }

    .loading-animation {
      transform: scale(calc(24/80));
      position: absolute;
      top: -20px;
      right: -23px;
    }

    .suggest-list {
      top: calc(18px + 50px);
      left: 9px;
      width: calc(100% - 18px);
      max-height: calc(100% - 18px - 50px);
      border-radius: 0px;
      background-color: rgba(255, 255, 255, 0);
      box-shadow: 0px 0px 4px 0 rgba(0, 0, 0, 0);
      -webkit-appearance: none;
      position: fixed;
    }
    .suggest-list::-webkit-scrollbar-thumb {
      border: none;
    }

    .suggest-list > .suggest {
      padding: 12.5px 20px;
      color: rgb(255, 255, 255);
    }

    .suggest-list > .suggest:hover,
    .suggest-list > .suggest.highlight {
      background-color: rgba(41, 148, 253, 0.5);
    }

    .tooltip {
      top: -18px;
      right: calc(8px - ((70px - 24px) / 2));
      width: 70px;
    }

    .tooltip > label {
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SearchWidget.vue